module.exports = __webpack_public_path__ + "img/tanghua1.4e06592e.png";